import { Vue, Ref, Prop, Emit, Component } from 'vue-property-decorator'
import {
    CustomerGroupsModalState, initialCustomerGroupsModalState
} from '@/modules/configurationModule/detail/accounting/billable/customer-groups/components/customer-groups-modal/customer-groups-modal.model'
import {
    CustomerGroupCreateRequest, CustomerGroupPatchInBatchRequest,
    CustomerGroupResponse
} from '@/modules/configurationModule/detail/accounting/billable/customer-groups/services/customer-groups.dto'

@Component({})
export default class CustomerGroupsModal extends Vue {
    @Ref() readonly customerGroupsModal!: any

    @Prop(String) readonly actionTitle!: string

    @Emit()
    create(): CustomerGroupCreateRequest {
        return { active: this.state.active, code: this.state.code, name: this.state.name }
    }

    @Emit()
    update(): CustomerGroupPatchInBatchRequest {
        return this.state
    }

    state: CustomerGroupsModalState
    constructor() {
        super()
        this.state = initialCustomerGroupsModalState()
    }

    async show(customerGroup?: CustomerGroupResponse): Promise<void> {
        await this.$validator.reset()

        this.state = initialCustomerGroupsModalState()
        if (customerGroup) {
            this.state = customerGroup
        }
        this.customerGroupsModal.show()
    }

    hide() {
        this.customerGroupsModal.hide()
    }

    get modelValidated(): boolean {
        const hasErrors: boolean = this.$validator.errors.any()
        const isDirty: boolean = this.$_someFieldIsDirty(this.fields)
        return !hasErrors && isDirty
    }

    private get _updateMode(): boolean {
        return (this.state.id !== -1)
    }

    async doAction(): Promise<void> {
        const valid = await this.$validator.validateAll()
        if (valid) {
            if (this._updateMode) {
                this.update() // emits an event
            } else {
                this.create() // emits an event
            }
        }
    }
}
